import AkCheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import AkErrorIcon from '@atlaskit/icon/glyph/error';
import AkInfoIcon from '@atlaskit/icon/glyph/info';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { G400, P400, R400, Y400 } from '@atlaskit/theme/colors';
import { FLAG_TYPE_INFO, FLAG_TYPE_SUCCESS, FLAG_TYPE_WARNING } from '@atlassian/mpac-types';
import React, { useCallback, useState } from 'react';
export function useAtlaskitFlags() {
  const [flags, setFlags] = useState([]);
  const addFlag = flag => {
    setFlags(current => [{
      id: flag.id,
      title: flag.title,
      description: flag.description,
      appearance: 'normal',
      icon: getFlagIconFromType(flag.type),
      actions: flag.actions
    }, ...current]);
  };
  const dismissFlag = useCallback(id => {
    setFlags(current => current.filter(flag => flag.id !== id));
  }, [setFlags]);
  return {
    flags,
    addFlag,
    dismissFlag
  };
}
export const getFlagIconFromType = flagType => {
  switch (flagType) {
    case FLAG_TYPE_INFO:
      return /*#__PURE__*/React.createElement(AkInfoIcon, {
        label: "",
        size: "medium",
        primaryColor: P400
      });
    case FLAG_TYPE_SUCCESS:
      return /*#__PURE__*/React.createElement(AkCheckCircleIcon, {
        label: "",
        size: "medium",
        primaryColor: G400
      });
    case FLAG_TYPE_WARNING:
      return /*#__PURE__*/React.createElement(WarningIcon, {
        label: "",
        size: "medium",
        primaryColor: Y400
      });
    default:
      return /*#__PURE__*/React.createElement(AkErrorIcon, {
        label: "",
        size: "medium",
        primaryColor: R400
      });
  }
};